// extracted by mini-css-extract-plugin
export default {"pre_loader":"LoaderPhotoList_pre_loader__VXHgv","skeleton":"LoaderPhotoList_skeleton__rquzU","skeleton-loading":"LoaderPhotoList_skeleton-loading__L5oUy"};